import { connect } from 'react-redux'
import Summary from './Summary.jsx'
import {
    getCollaborativeIndexationCampaignIndexationType,
    getCollaborativeIndexationCreationFields,
} from '../../../../redux/collaborativeIndexations/selectors'

const mapStateToProps = state => ({
    indexationType: getCollaborativeIndexationCampaignIndexationType(state),
    fields: getCollaborativeIndexationCreationFields(state),
})

export const SummaryContainer = connect(
    mapStateToProps,
)(Summary)
